/* eslint-disable react/prefer-stateless-function */

import React from 'react';
import ReactModal from 'react-modal';

// DEPRECATED: use src/components/dialog/ConfirmationDialog.component.jsx
class ConfirmationDialog extends React.Component {
  static defaultProps = {
    children: [],
  };

  render() {
    const { title, leftButtonText, onLeft, rightButtonText, onRight, onCancel } = this.props;
    return (
      <ReactModal
        isOpen
        onRequestClose={onCancel}
        closeTimeoutMS={0}
        contentLabel={title}
        ariaHideApp
        shouldCloseOnOverlayClick
        role="dialog"
        style={{
          overlay: {
            zIndex: 500,
          },
        }}
        className={{
          base: 'dialog-container',
          afterOpen: 'dialog-container',
          beforeClose: 'dialog-container',
        }}
      >
        <div data-bem="ConfirmationDialog__content--settings" className="dialog">
          <div className="dialog-header">
            <h2>{title}</h2>
            <div className="close" role="button" tabIndex={0} onClick={onCancel} />
          </div>
          <div className="body">{this.props.children}</div>
          <div className="dialog-footer">
            <div data-cy="confirm-left-button" className="btn btn-violet-link" role="button" tabIndex={0} onClick={onLeft}>
              {leftButtonText}
            </div>
            <div data-cy="confirm-right-button" className="btn btn-violet-link" role="button" tabIndex={0} onClick={onRight}>
              {rightButtonText}
            </div>
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default ConfirmationDialog;
